import { useEffect, useState, useContext, useCallback } from "react";
import { format, parseISO } from 'date-fns'
import { BsPlayFill, BsStopFill, BsArrowRepeat, BsCheck2All, BsXCircle, BsCheck2 } from 'react-icons/bs'
import { BiSave, BiArrowBack, BiCheckCircle } from 'react-icons/bi'
import { TbHandStop } from 'react-icons/tb'
import OrderContext from '../../../contexts/OrderContext'
import UserContext from '../../../contexts/UserContext'

import { DivisionValue, OperationTime, OrderStatusCode, OrderType, QCDowntimeCodes } from '../../../constants/Enum'
import { DgtPdOrderOperationLog, DgtPdDowntimeCode, DgtPdProductionOrder, DgtPdWorkCenter, BulkStatus, OrderType as OrdType } from '../../../models'
import { getMinuteTimeV2, isDiffDay, getBeforeMidnight, getMidnight, formatDateFromUnix } from '../../../utilities/Format'
import { convertJson } from '../../../utilities/Validate'
import MessageConfirmDialog from '../../Dialogs/MessageConfirm'

import { DataStore, SortDirection } from '@aws-amplify/datastore'
import { NumberInput } from '../../../components/NumberInput'
import Select from 'react-select';

import Modal from '../../../components/Modal';
import Badge from "../../../components/Badge";
import DatePicker from 'react-datepicker'

import { PubSub } from 'aws-amplify'
import {
  formatDateObject
} from '../../../utilities/Format'
import { Department } from "../../../models";
import { updateInProgressDirectly } from '../../../apis'
import { RadioGroup } from '@headlessui/react'
import { SHIFT } from "../../../constants/EnumType";

import { Alert } from '@aws-amplify/ui-react';

const WorkCenterForm = ({ 
  workCenter, 
  timeTitle, 
  onBack, 
  logId, 
  isEditTime = false, 
  lastLogs = [],
  iotStartTime = 0,
  iotStopTime = 0,
  iotWeight = { weight: 0, timestamp: '' },
  iotEnable = false,
  isRequiredBatchLotNo = true
}) => {
  const { order, setOrder } = useContext(OrderContext)

  let parsedBatchNos = []
  if (order.actualBatchNumbers) {
    parsedBatchNos = convertJson(order.actualBatchNumbers)
  } else if (order.batchNumbers) {
    parsedBatchNos = convertJson(order.batchNumbers)
  }
  const batchNoList = [...new Set(parsedBatchNos
    .filter(bn => !bn.includes('_'))
    .sort((a, b) => b.localeCompare(a)))]

  const convertDateNowFormat = format(new Date(), 'yyyy-MM-dd')

  const [showConfirm, setShowConfirm] = useState(false);
  const [showWarningReset, setShowWarningReset] = useState(false);
  const [showWarningNotSave, setShowWarningNotSave] = useState(false);
  const [showAlertSaveOnMidNight, setShowAlertSaveOnMidNight] = useState(false);

  const handleClose = () => {
    setShowConfirm(false)
    setErrorSave(undefined)
  };
  const [downTimeCodes, setDownTimeCodes] = useState([])

  const [isFinalProduce, setFinalProduce] = useState(false)

  const [isAddMoreBulk, setIsAddMoreBulk] = useState(false)

  const [ errorSave, setErrorSave ] = useState()

  const { user } = useContext(UserContext)
  const defaultLog = {
    pdOrderOperationId: workCenter.id,
    timeType: timeTitle,
    productionOrderId: order.id,
    materialCode: order.materialCode,
    materialDescription: order.materialDescription,
    orderQty: order.orderQty,
    orderType: order.orderType ? order.orderType : OrdType.FG,
    operationNo: workCenter.operationNo,
    batchNo: isRequiredBatchLotNo && batchNoList.filter(bn => !bn.includes('_')).length > 0 && timeTitle !== OperationTime.SOAP_BASE ? batchNoList[0] : undefined,
    postingDate: convertDateNowFormat,
    workCenterId: workCenter.actualWorkCenterId ? workCenter.actualWorkCenterId : workCenter.workCenterId,
    workCenterDescription: workCenter.actualWorkCenterDescription ? workCenter.actualWorkCenterDescription : workCenter.workCenterDescription,
    shift: timeTitle === OperationTime.SOAP_BASE && lastLogs.length > 0 ? lastLogs[0].shift : undefined,
    startedTime: 0,
    finishedTime: 0,
    workingStatus: true,
    downtimeCode: '',
    downtimeDescription: '',
    mch: lastLogs.length === 0 ? '' : lastLogs[0].mch,
    yield: timeTitle === OperationTime.RUN_TIME && order.materialType === OrderType.BULK ? order.orderQty : undefined,
    createdBy: user?.name || user?.username,
    createdVersion: 'c9ed51c'
  }

  const [record, setRecord] = useState(new DgtPdOrderOperationLog(defaultLog))

  useEffect(() => {
    const fetchLatestIot = async () => {
      const iotWorkCenterId = workCenter.actualWorkCenterId ? workCenter.actualWorkCenterId : workCenter.workCenterId
      await PubSub.publish(`$aws/things/${iotWorkCenterId}/shadow/name/machine_status/get`, {});
    }
    fetchLatestIot()
  }, [ workCenter ])

  const onPostingDateChanged = (date) => {
    let currentRecord = { ...record }
    currentRecord.postingDate = format(date, 'yyyy-MM-dd')
    setRecord(currentRecord)
  }

  const startedRecord = (e, timestamp) => {
    let currentRecord = { ...record }
    currentRecord.startedTime = timestamp ? timestamp : Math.round(Date.now() / 1000)
    currentRecord.postingDate = format(new Date(), 'yyyy-MM-dd')
    setRecord(currentRecord)
  }

  const stoppedRecord = (e, timestamp) => {
    let currentRecord = { ...record }
    currentRecord.finishedTime = timestamp ? timestamp : Math.round(Date.now() / 1000)
    currentRecord.totalTime = currentRecord.finishedTime - currentRecord.startedTime
    setShowAlertSaveOnMidNight(isDiffDay(currentRecord.startedTime, currentRecord.finishedTime))
    setRecord(currentRecord)
  }

  useEffect(() => {
    if (record.startedTime > 0) return

    if (iotStartTime > 0 && record.timeType === OperationTime.RUN_TIME) {
      startedRecord(null, iotStartTime)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ iotStartTime, record.timeType, record.startedTime ])

  useEffect(() => {
    // init with off -> if current = on -> set stop else not set
    if (record.finishedTime > 0) return
    
    if (iotStopTime > 0 && record.timeType === OperationTime.RUN_TIME
      && record.startedTime > 0 && iotStopTime >= record.startedTime) {
      stoppedRecord(null, iotStopTime)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ record.startedTime, record.timeType, iotStopTime, record.finishedTime ])

  useEffect(() => {
    let currentRecord = { ...record }
    if (iotWeight.weight > 0) {
      const currentYield = currentRecord.yield || 0
      currentRecord.yield = currentYield + iotWeight.weight
    } else {
      delete currentRecord.yield
    }

    if (order.materialType === OrderType.BULK && !isAddMoreBulk) {
      if (currentRecord.yield) {
        const calculatedScrap = order.orderQty - currentRecord.yield
        currentRecord.scrap = calculatedScrap > 0 ? parseFloat(calculatedScrap.toFixed(3)) : 0
      } else {
        delete currentRecord.scrap
      }
    }
    setRecord(currentRecord)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ iotWeight.weight, iotWeight.timestamp ])

  const resetYield = useCallback(() => {
    let currentRecord = { ...record }
    currentRecord.yield = 0
    currentRecord.scrap = order.orderQty
    setRecord(currentRecord)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const resetTimeRecord = () => {
    let currentRecord = { ...record }
    currentRecord.startedTime = 0
    currentRecord.finishedTime = 0
    currentRecord.totalTime = 0
    setRecord(currentRecord)
    setShowWarningReset(false)
  }

  const onBatchNoChangedForInput = (e) => {
    let currentRecord = { ...record }
    currentRecord.batchNo = e.currentTarget.value
    setRecord(currentRecord)
  }

  const onBatchNoChangedForSelect = (e) => {
    let currentRecord = { ...record }
    currentRecord.batchNo = e.value
    setRecord(currentRecord)
  }

  const onDownTimeCodeChanged = (e) => {
    let currentRecord = { ...record }
    currentRecord.downtimeCode = e.value
    currentRecord.downtimeDescription = e.description
    if (e.baseTimeForBulk) {
      if (lastLogs && lastLogs.length > 0 &&
        lastLogs[0].timeType === 'Down Time' && lastLogs[0].downtimeCode === e.value ) {
        currentRecord.downtimeBaseTime = Math.max(
          getDiscountDowntime(order, e.baseTimeForBulk) - getMinuteTimeV2(lastLogs[0].startedTime, lastLogs[0].finishedTime), 0)
      } else {
        currentRecord.downtimeBaseTime = getDiscountDowntime(order, e.baseTimeForBulk)
      }
    } else {
      currentRecord.downtimeBaseTime = 0
    }
    setRecord(currentRecord)
  }

  const onShiftChanged = (value) => {
    let currentRecord = { ...record }
    currentRecord.shift = `${value}`
    setRecord(currentRecord)
  }

  const onMchChanged = (e) => {
    let currentRecord = { ...record }
    if (e.currentTarget.value.length <= 2 && !isNaN(Number(e.currentTarget.value))) {
      currentRecord.mch = e.currentTarget.value
      setRecord(currentRecord)
    }
  }

  const onEmployeeRTChanged = (e) => {
    let currentRecord = { ...record }
    if (e.currentTarget.value) {
      currentRecord.totalEmployeeRT = parseInt(e.currentTarget.value)
    } else {
      delete currentRecord.totalEmployeeRT
    }
    setRecord(currentRecord)
  }

  const onEmployeeOTChanged = (e) => {
    let currentRecord = { ...record }
    if (e.currentTarget.value) {
      currentRecord.totalEmployeeOT = parseInt(e.currentTarget.value)
    } else {
      delete currentRecord.totalEmployeeOT
    }
    setRecord(currentRecord)
  }

  const onYieldChanged = (e) => {
    let currentRecord = { ...record }

    if (e.currentTarget.value) {
      currentRecord.yield = parseFloat(e.currentTarget.value)
    } else {
      delete currentRecord.yield
    }

    if (order.materialType === OrderType.BULK && !isAddMoreBulk) {
      if (currentRecord.yield) {
        const calculatedScrap = order.orderQty - currentRecord.yield
        currentRecord.scrap = calculatedScrap > 0 ? parseFloat(calculatedScrap.toFixed(3)) : 0
      } else {
        delete currentRecord.scrap
      }
    }

    setRecord(currentRecord)
  }

  const onScrapChanged = (e) => {
    let currentRecord = { ...record }

    if (e.currentTarget.value) {
      currentRecord.scrap = parseFloat(e.currentTarget.value)
    } else {
      delete currentRecord.scrap
    }

    setRecord(currentRecord)
  }

  const onFinalProduceChanged = (e) => {
    setFinalProduce(e.currentTarget.checked)
    if (!e.currentTarget.checked) {
      let currentRecord = { ...record }
      delete currentRecord.bulkUsedQty
      setRecord(currentRecord)
    }
  }

  const onBulkQuantityUsedChanged = (e) => {
    let currentRecord = { ...record }

    if (e.currentTarget.value) {
      currentRecord.bulkUsedQty = parseFloat(e.currentTarget.value)
    } else {
      delete currentRecord.bulkUsedQty
    }

    setRecord(currentRecord)
  }

  const onBulkStatusChanged = e => {
    let currentRecord = { ...record }
    if (e.currentTarget.value) {
      currentRecord.bulkStatus = e.currentTarget.value
      currentRecord.bulkStatusBy = user?.name || user?.username
      currentRecord.bulkStatusDate = formatDateObject(new Date())
      currentRecord.bulkStatusDateTime = Math.floor(Date.now() / 1000)
    } else {
      delete currentRecord.bulkStatus
      delete currentRecord.bulkStatusBy
      delete currentRecord.bulkStatusDate
      delete currentRecord.bulkStatusDateTime
    }
    setRecord(currentRecord)
  }

  const onBulkStatusCommentChanged = e => {
    let currentRecord = { ...record }
    if (e.currentTarget.value) {
      currentRecord.bulkStatusComment = e.currentTarget.value
    } else {
      delete currentRecord.bulkStatusComment
    }
    setRecord(currentRecord)
  }

  const onSaveRecord = async () => {
    try {
      const originaLog = await DataStore.query(DgtPdOrderOperationLog, logId)
      if (originaLog) {
        const updateRecord = { ...record }
        if (isDiffDay(updateRecord.startedTime, updateRecord.finishedTime)) {
          const mid = getMidnight(updateRecord.finishedTime)
          updateRecord.startedTime = mid
          updateRecord.postingDate = format(new Date(), 'yyyy-MM-dd')
          updateRecord.totalTime = updateRecord.finishedTime - mid

          const beforeMid = getBeforeMidnight(record.startedTime)

          const beforeMidInsert = {
            ...record,
            finishedTime: beforeMid,
            totalTime: beforeMid - record.startedTime
          }
          delete beforeMidInsert.yield
          delete beforeMidInsert.scrap
          delete beforeMidInsert.bulkUsedQty

          removeNulOrEmpty(beforeMidInsert)

          await DataStore.save(new DgtPdOrderOperationLog(beforeMidInsert))

          const minOfDownTime = beforeMidInsert.timeType === OperationTime.DOWN_TIME ? 
            totalTime(beforeMidInsert, beforeMidInsert.downtimeBaseTime) : -1
          if (minOfDownTime > 0) {
            // logic : if downtime of before mid record > 0 then clear downtime base of after mid record
            updateRecord.downtimeBaseTime = 0
          } else if (minOfDownTime === 0) {
            // logic : else minus total time of before mid record from downtime base of after mid record
            updateRecord.downtimeBaseTime -= getMinuteTimeV2(beforeMidInsert.startedTime, beforeMidInsert.finishedTime)
          }
        }
        const updateLog = DgtPdOrderOperationLog.copyOf(originaLog, updated => {
          updated.batchNo = updateRecord.batchNo === '' ? null : updateRecord.batchNo
          updated.postingDate = updateRecord.postingDate
          updated.shift = updateRecord.shift
          updated.mch = updateRecord.mch
          updated.startedTime = updateRecord.startedTime
          updated.finishedTime = updateRecord.finishedTime
          updated.totalTime = updateRecord.totalTime
          updated.totalEmployeeRT = updateRecord.totalEmployeeRT
          updated.totalEmployeeOT = updateRecord.totalEmployeeOT
          if (updateRecord.yield) {
            updated.yield = updateRecord.yield
          } else {
            delete updated.yield
          }

          if (updateRecord.scrap) {
            updated.scrap = updateRecord.scrap
          } else {
            delete updated.scrap
          }

          if (updateRecord.bulkUsedQty) {
            updated.bulkUsedQty = updateRecord.bulkUsedQty
          } else {
            delete updated.bulkUsedQty
          }
          if (updateRecord.downtimeCode) {
            updated.downtimeCode = updateRecord.downtimeCode
            updated.downtimeDescription = updateRecord.downtimeDescription
          }
          if (updateRecord.downtimeBaseTime) {
            updated.downtimeBaseTime = updateRecord.downtimeBaseTime
          } else {
            delete updated.downtimeBaseTime
          }

          if (updateRecord.bulkStatus) {
            updated.bulkStatus = updateRecord.bulkStatus
            updated.bulkStatusBy = updateRecord.bulkStatusBy
            updated.bulkStatusDate = updateRecord.bulkStatusDate
            updated.bulkStatusDateTime = updateRecord.bulkStatusDateTime
            updated.materialCode = order.materialCode
            updated.materialDescription = order.materialDescription
          }
          if (updateRecord.bulkStatusComment) {
            updated.bulkStatusComment = updateRecord.bulkStatusComment
          }

          updated.updatedBy = user?.name || user?.username
          updated.updatedVersion = 'c9ed51c'
        })
        await DataStore.save(updateLog)
      } else {
        const insert = { ...record }
        if (isDiffDay(record.startedTime, record.finishedTime)) {
          const mid = getMidnight(insert.finishedTime)
          insert.startedTime = mid
          insert.postingDate = format(new Date(), 'yyyy-MM-dd')
          insert.totalTime = insert.finishedTime - mid

          const beforeMid = getBeforeMidnight(record.startedTime)

          const beforeMidInsert = {
            ...record,
            finishedTime: beforeMid,
            totalTime: beforeMid - record.startedTime
          }
          delete beforeMidInsert.yield
          delete beforeMidInsert.scrap
          delete beforeMidInsert.bulkUsedQty

          removeNulOrEmpty(beforeMidInsert)
          
          await DataStore.save(new DgtPdOrderOperationLog(beforeMidInsert))

          // const minOfTotalTime = beforeMidInsert.totalTime
          const minOfDownTime = beforeMidInsert.timeType === OperationTime.DOWN_TIME ? 
            totalTime(beforeMidInsert, beforeMidInsert.downtimeBaseTime) : -1
          if (minOfDownTime > 0) {
            // logic : if downtime of before mid record > 0 then clear downtime base of after mid record
            insert.downtimeBaseTime = 0
          } else if (minOfDownTime === 0) {
            // logic : else minus total time of before mid record from downtime base of after mid record
            insert.downtimeBaseTime -= getMinuteTimeV2(beforeMidInsert.startedTime, beforeMidInsert.finishedTime)
          }
        }
        await DataStore.save(new DgtPdOrderOperationLog(insert))
        updateInProgressOrder(order, setOrder, record.postingDate)
      }
      setShowConfirm(false)
      onBack()
    } catch (error) {
      console.log(error)
      setErrorSave(error.message)
    }
  }

  useEffect(() => {
    if (record.timeType === OperationTime.DOWN_TIME) {
      const fetchDownTimeCodes = async () => {
        try {
          const downTimeCodes = await DataStore.query(DgtPdDowntimeCode, s => s.active("eq", true), {
            sort: s => s.id(SortDirection.ASCENDING)
          })
          setDownTimeCodes(downTimeCodes)
        } catch (error) {
          console.log(error)
        }
      }
      fetchDownTimeCodes()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record])

  useEffect(() => {
    if (logId) {
      const subscription = DataStore.observeQuery(
        DgtPdOrderOperationLog,
        log => log.id('eq', logId)
      ).subscribe(snapshot => {
        const { items, isSynced } = snapshot;
        if (isSynced && items.length > 0) {
          const log = items[0]
          if (!log.postingDate) {
            subscription.unsubscribe()
            return
          }
          const currentRec = { ...log, batchNo: log.batchNo || undefined }
          setRecord(currentRec)
          setFinalProduce(log.bulkUsedQty && log.bulkUsedQty > 0)
        }
      });
      return () => subscription.unsubscribe()
    }
    return () => {}
  }, [logId])

  const onEditStartTimeChanged = (date) => {
    let currentRecord = { ...record }
    currentRecord.startedTime = Math.round(date.getTime() / 1000)
    currentRecord.totalTime = currentRecord.finishedTime - currentRecord.startedTime
    setRecord(currentRecord)
  }

  const onEditEndTimeChanged = (date) => {
    let currentRecord = { ...record }
    currentRecord.finishedTime = Math.round(date.getTime() / 1000)
    currentRecord.totalTime = currentRecord.finishedTime - currentRecord.startedTime
    setRecord(currentRecord)
  }

  const onIsAddMoreBulkChanged = (e) => {
    setIsAddMoreBulk(e.currentTarget.checked)
    if (e.currentTarget.checked) {
      let currentRecord = { ...record }
      delete currentRecord.scrap
      delete currentRecord.yield
      setRecord(currentRecord)
    }
  }

  const onBackPress = () => {
    const isBlocked = isDisableSubmit(record, isRequiredBatchLotNo)
    if (record.startedTime > 0 && !isBlocked) {
      setShowWarningNotSave(true)
    } else {
      onBack()
    }
  }

  const stopRecordWithStopMachineIot = (e) => {
    stoppedRecord(e)
    const stopMachine = async () => {
      const iotWorkCenterId = workCenter.actualWorkCenterId ? workCenter.actualWorkCenterId : workCenter.workCenterId
      const now = Math.round(Date.now() / 1000)
      await PubSub.publish(`$aws/things/${iotWorkCenterId}/shadow/name/machine_status/update`, {
        "state": { "desired": {
          "machine": iotWorkCenterId,
          "status": "on",
          "current_time": `${now}`
        }}
      });
    }
    stopMachine()
  }

  const readWeightIot = async () => {
    const workCenterId = workCenter.actualWorkCenterId ? workCenter.actualWorkCenterId : workCenter.workCenterId
    const iotWc = await DataStore.query(DgtPdWorkCenter, workCenterId)
    await PubSub.publish(`$aws/things/${iotWc.iotId}/shadow/name/Weight_Scale/get`, {});
  }
  
  const isDisableInput = (!record.startedTime && record.timeType !== OperationTime.SOAP_BASE) || user.department === Department.QC
  const downtimeBaseTime = record.downtimeBaseTime ? record.downtimeBaseTime : 0

  return <div className='container px-0 mx-auto xl:px-24 2xl:px-36 '>
    <div className="flex items-center justify-between mt-3">
      <button className='flex flex-row items-center justify-center gap-1 px-3 py-2 text-sm text-gray-500 border border-gray-400 rounded md:text-base h-fit hover:bg-gray-200'
        onClick={onBackPress}><BiArrowBack /> กลับ</button>
      <div className='text-center'>
        <h4 className="font-bold underline">{record.timeType}</h4>
        <h6 className="px-2 text-xs md:text-base text-muted">Operation : {workCenter.operationNo} / WC : {workCenter.actualWorkCenterDescription ? workCenter.actualWorkCenterDescription : workCenter.workCenterDescription} ({workCenter.actualWorkCenterId ? workCenter.actualWorkCenterId : workCenter.workCenterId})</h6>
      </div>
      <button className='flex flex-row items-center justify-center gap-1 px-3 py-2 text-sm text-white bg-green-600 border rounded md:text-base h-fit hover:bg-green-700 disabled:opacity-75'
        onClick={() => setShowConfirm(true)} disabled={isDisableSubmit(record, isRequiredBatchLotNo)}><BiSave /> บันทึก</button>
    </div>
    <div className='grid grid-cols-1 gap-5 mt-3 sm:grid-cols-4 lg:grid-cols-6'>
      <div className='lg:col-span-2 '>
        <h6 className='mb-2'>Batch No.</h6>
        <input type="text" placeholder={`ใส่ Batch No${record.timeType === OperationTime.SOAP_BASE ? ' ของ SOAP BASE' : ' ที่ไม่มีในระบบ'}`}
          onChange={onBatchNoChangedForInput}
          value={record.batchNo}
					className={`${record.timeType === OperationTime.SOAP_BASE || isEditTime || batchNoList.length === 0 ? '':'hidden'} input-form-text`}
				></input>
				<Select
          className={`${record.timeType === OperationTime.SOAP_BASE || isEditTime ? 'hidden':''}`}
          placeholder="กรุณาเลือก Batch No."
          onChange={onBatchNoChangedForSelect}
          value={{ value: record.batchNo, label: record.batchNo }}
          options={batchNoList.map(batch => {
            return { value: batch, label: batch, isDisabled: batch.includes('_') }
          })}
          isOptionDisabled={option => option.isDisabled}
          isDisabled={isDisableInput}
          isSearchable={false}
        />
      </div>
      <div className='lg:col-span-2'>
        <h6 className="mb-2 before:content-['*'] before:mr-1 before:text-red-500">Shift (เลือกกะก่อนบันทึก)</h6>
        <RadioGroup
          onChange={onShiftChanged}
          value={record.shift}
          disabled={isDisableInput}
          >
          <div className="flex">
            {Object.keys(SHIFT).map(shf => (
              <RadioGroup.Option
                key={shf}
                value={SHIFT[shf].value}
                className={({ active, checked }) =>
                  ` border ${checked ? ' border-green-700 bg-green-100' : ' border-[#CCCCCC] '} p-1.5 flex-1 cursor-pointer first:rounded-l-md last:rounded-r-md`
                }
              >
                {({ active, checked, disabled }) => (
                  <div className={`flex items-center justify-center w-full gap-1${disabled ? ' opacity-50' : ''}`}>
                    {checked && <BiCheckCircle className="text-green-700 " size={20}/>}
                    <RadioGroup.Label
                      as="p"
                      className={checked ? 'font-bold text-green-700' : ''}
                    >
                      {SHIFT[shf].display}
                    </RadioGroup.Label>
                  </div>
                )}
              </RadioGroup.Option>
            ))}
          </div>
        </RadioGroup>
      </div>
      <div>
        <h6 className="mb-2 before:content-['*'] before:mr-1 before:text-red-500">เบอร์ถังพัก/เครื่อง</h6>
        <input type="text" onChange={onMchChanged} value={record.mch} placeholder="ระบุเบอร์ก่อนบันทึก"
          className='input-form-text'
          disabled={isDisableInput || record.timeType === OperationTime.SOAP_BASE}/>
        <small className="text-xs italic text-yellow-500">พิมพ์เลข เช่น 1 หรือ 01 เท่านั้น</small>
      </div>
      <div>
        <h6 className='mb-2'>Posting Date</h6>
        <DatePicker
					className='input-form-date'
					selected={parseISO(record.postingDate)}
					onChange={onPostingDateChanged}
					dateFormat="dd/MM/yyyy"
          disabled={isDisableInput || record.timeType === OperationTime.SOAP_BASE}
				/>
      </div>
      <div className={`${isEditTime ? 'hidden':''} card-record col-span-2`}>
        {/* stamp time cards */}
        <div className='flex'>
          <label className="font-bold ">บันทึกเวลา</label>
          {isEditTime || QCDowntimeCodes.includes(record.downtimeCode) ? null : <h6 className="flex items-center ml-2 work-center-edit"
            onClick={() => setShowWarningReset(true)}><BsArrowRepeat className="mr-1" />รีเซ็ต</h6>}
        </div>
        <div className='flex gap-5 mt-2'>
          <div className='text-center basis-1/2'>
            <button className='w-full text-sm btn-success'
              disabled={record.startedTime > 0 || record.timeType === OperationTime.SOAP_BASE}
              onClick={startedRecord}
            ><BsPlayFill /> กดเริ่มผลิต</button>
            <small className="text-muted">{record.startedTime > 0 ?
              format(new Date(record.startedTime * 1000), 'dd-MM-yyyy HH:mm') : '-'}</small>
          </div>
          <div className='text-center basis-1/2'>
            <button className='w-full text-sm btn-danger'
              disabled={record.startedTime === 0 || (QCDowntimeCodes.includes(record.downtimeCode) && user.department !== Department.QC)}
              onClick={stoppedRecord}
            ><BsStopFill /> กดหยุดผลิต</button>
            <small className="text-muted">{record.finishedTime > 0 ?
              format(new Date(record.finishedTime * 1000), 'dd-MM-yyyy HH:mm') : '-'}</small>
          </div>
        </div>
        <div className={`${iotEnable ? '':'hidden '}mt-2 text-center`}>
          <button className='w-full text-sm btn-outline-danger'
            disabled={record.startedTime === 0}
            onClick={stopRecordWithStopMachineIot}
          ><BsStopFill /> กดหยุดผลิตก่อนพักเบรค</button>
          <small className="italic text-muted">สำหรับกรณีเดินเครื่องต่อเนื่อง</small>
        </div>
      </div>
      <div className={`${isEditTime ? '':'hidden'} card-record col-span-2`}>
        {/* edit time cards */}
        <div className='flex'>
          <label className="font-bold ">แก้ไขเวลา</label>
        </div>
        <EditStartStopTime
          start={record.startedTime ? new Date(record.startedTime * 1000) : new Date()}
          stop={record.finishedTime ? new Date(record.finishedTime * 1000): new Date()}
          onStartDateTimeChanged={onEditStartTimeChanged}
          onStopDateTimeChanged={onEditEndTimeChanged} />
      </div>
      <div className={`card-record col-span-2`}>
        <label className="font-bold ">บันทึกจำนวนคน</label>
        <div className='flex gap-5 mt-2'>
          <div className='basis-1/2'>
            <NumberInput
              placeHolder="จำนวนคน"
              onChanged={onEmployeeRTChanged}
              value={record.totalEmployeeRT}
              isInvalid={record.totalEmployeeRT && (record.totalEmployeeRT <= 0 || record.totalEmployeeRT > 100)}
              disabled={isDisableInput || record.timeType === OperationTime.SOAP_BASE} />
            <small className="float-right ">RT</small>
          </div>
          <div className='basis-1/2'>
            <NumberInput
              placeHolder="จำนวนคน"
              onChanged={onEmployeeOTChanged}
              value={record.totalEmployeeOT}
              isInvalid={record.totalEmployeeOT && (record.totalEmployeeOT <= 0 || record.totalEmployeeOT > 100)}
              disabled={isDisableInput || record.timeType === OperationTime.SOAP_BASE} />
            <small className="float-right ">OT</small>
          </div>
        </div>
      </div>
      <div className={`${record.timeType === OperationTime.RUN_TIME ? '':'hidden'} card-record col-span-2`}>
        <div className='flex justify-between mb-2'>
          <label className="font-bold">บันทึกจำนวนผลิตได้</label>
          <div className={`${order.materialType === OrderType.BULK ? '':'hidden'} flex items-center gap-2`}>
            <input
              type="checkbox"
              onChange={onIsAddMoreBulkChanged}
              checked={isAddMoreBulk | false}
              disabled={isDisableInput}
            />
            <label className="font-bold ">เบิกเพิ่ม ?</label>
          </div>
        </div>
        <div className="flex gap-2">
          <div className={iotEnable && order.id.startsWith('8') ? 'basis-1/2':' basis-full'}>
            <NumberInput
              placeHolder="จำนวนผลิตได้"
              onChanged={onYieldChanged}
              value={record.yield}
              disabled={isDisableInput} />
            <small className="float-right">{order.materialUnit}</small>
          </div>
          {iotEnable && order.id.startsWith('8') ? <button className={'basis-1/2 btn-primary'} onClick={readWeightIot}>{iotWeight.weight > 0 ? 'กดเพิ่มน้ำหนัก' : 'กดดึงน้ำหนัก'}</button> : null}
        </div>
        {iotEnable && order.id.startsWith('8') ? <div>
          <button className={'btn-outline-danger w-full mt-3'} onClick={resetYield}>
            ล้างค่าน้ำหนัก = 0
          </button>
        </div> : null}
      </div>
      <div className={`${record.timeType === OperationTime.RUN_TIME && order.materialType === OrderType.BULK ? '':'hidden'} card-record col-span-2 lg:col-start-5`}>
        <div className='flex items-center justify-between mb-2'>
          <label className="font-bold ">บันทึก Scrap</label>
          <small>{isAddMoreBulk ? "ปิดการคำนวณ":"คำนวณอัตโนมัติ"}</small>
        </div>
        <NumberInput
          placeHolder="จำนวน scrap"
          onChanged={onScrapChanged}
          value={record.scrap}
          disabled={isAddMoreBulk || isDisableInput} />
        <small className="float-right">{order.materialUnit}</small>
      </div>
      <div className={`${record.timeType === OperationTime.RUN_TIME && order.materialType === OrderType.FG ? '':'hidden'} card-record col-span-2 lg:col-start-5`}>
        <div className='mb-2'>
          <input
            className='mr-2'
            type="checkbox"
            onChange={onFinalProduceChanged}
            checked={isFinalProduce | false}
          />
          <label className="font-bold ">เปิดเพื่อบันทึกน้ำหนัก Bulk ที่ใช้ผลิต</label>
        </div>
        <NumberInput
          placeHolder="จำนวน Bulk ที่ใช้ผลิต"
          onChanged={onBulkQuantityUsedChanged}
          value={record.bulkUsedQty}
          disabled={!isFinalProduce} />
        <small className="float-right">KG.</small>
      </div>
      <div className={`${record.timeType === OperationTime.SOAP_BASE && order.materialType === OrderType.BULK ? '':'hidden'} card-record col-span-2 col-start-2 lg:col-start-auto`}>
        <label className="inline-block mb-2 font-bold ">จำนวน SOAP BASE</label>
        <NumberInput
          placeHolder="จำนวน SOAP BASE ที่ใช้"
          onChanged={onBulkQuantityUsedChanged}
          value={record.bulkUsedQty}
        />
        <small className="float-right">KG.</small>
      </div>
      <div className={`${record.timeType === OperationTime.DOWN_TIME ? '':'hidden'} card-record col-span-2`}>
        <label className="inline-block mb-2 font-bold ">บันทึก DownTime</label>
        <Select
          placeholder="เลือก Code"
          value={record.downtimeCode ? { 
            value: record.downtimeCode, 
            label: `${record.downtimeCode}-${record.downtimeDescription}`, 
            description: record.downtimeDescription 
          } : null}
          onChange={onDownTimeCodeChanged}
          options={downTimeCodes.map(dc => {
            return { 
              value: dc.id, 
              label: `${dc.id}-${dc.description}`, 
              description: dc.description,
              baseTimeForBulk: dc.baseTimeForBulk
            }
          })}
          isSearchable={true}
          isDisabled={isDisableInput}
        />
        <small className=' text-muted'>{record.downtimeBaseTime ? `เวลาสำหรับ ${isTomi(order) ? 'โทมิ' : order.division} : ${downtimeBaseTime} นาที`: '-'}</small>
      </div>
      <div className={`${record.timeType === OperationTime.DOWN_TIME && QCDowntimeCodes.includes(record.downtimeCode) ? '':'hidden'} card-record col-span-2 col-start-0 lg:col-start-5 space-y-2`}>
        <div className="flex justify-between">
          <label className="inline-block font-bold ">บันทึกผลการทดสอบ Bulk</label>
          <p><Badge variant="danger ml-1">บันทึกโดย QC Lab</Badge></p>
        </div>
        <div className="flex flex-row gap-2">
        {Object.keys(BulkStatus).map(blkSts => 
          <div className="relative bulk-status basis-1/3" key={blkSts}>
            <input className="hidden peer" type="radio" id={`radio${blkSts}`} value={blkSts} checked={record.bulkStatus === blkSts}
              name='bulk_status' disabled={!record.finishedTime || user.department !== Department.QC || record.approveBulkStatusDateTime > 0} onChange={onBulkStatusChanged}/>
            {blkSts === BulkStatus.PASS && 
            <label className="label-bulk-status peer-checked:border-green-600 peer-checked:text-green-600 peer-checked:bg-green-100 peer-disabled:text-gray-400" htmlFor={`radio${blkSts}`}>
              {blkSts === BulkStatus.PASS && <BsCheck2 size={24} className='text-green-600' />}
              <span>{blkSts}</span>
            </label>}
            {blkSts === BulkStatus.HOLD && 
            <label className="label-bulk-status peer-checked:border-yellow-600 peer-checked:text-yellow-600 peer-checked:bg-yellow-100 peer-disabled:text-gray-400" htmlFor={`radio${blkSts}`}>
              {blkSts === BulkStatus.HOLD && <TbHandStop size={24} className='text-yellow-600' />}
              <span>{blkSts}</span>
            </label>}
            {blkSts === BulkStatus.REJECT && 
            <label className="label-bulk-status peer-checked:border-red-600 peer-checked:text-red-600 peer-checked:bg-red-100 peer-disabled:text-gray-400" htmlFor={`radio${blkSts}`}>
              {blkSts === BulkStatus.REJECT && <BsXCircle size={24} className='text-red-600' />}
              <span>{blkSts}</span>
            </label>}
          </div>
        )}
        </div>
        <div>
          <small>Comment</small>
          <textarea
            className={`input-form-text`} placeholder="ระบุเหตุผล (ถ้ามี)"
            disabled={!record.finishedTime || user.department !== Department.QC || record.approveBulkStatusDateTime > 0}
            onChange={onBulkStatusCommentChanged}
            value={record.bulkStatusComment}
          />
        </div>
        <div className="grid grid-cols-2">
          <div className="text-center ">
            <small className="flex justify-center gap-1 text-muted"><BsCheck2 size={20} className='text-green-600' />บันทึกโดย</small>
            <h6>{record.bulkStatusBy}</h6>
            <h6>{formatDateFromUnix(record.bulkStatusDateTime)}</h6>
          </div>
          <div className="text-center ">
            <small className="flex justify-center gap-1 text-muted"><BsCheck2All size={20} className='text-green-600' />อนุมัติโดย</small>
            <h6>{record.approveBulkStatusBy}</h6>
            <h6>{formatDateFromUnix(record.approveBulkStatusDateTime)}</h6>
          </div>
        </div>
      </div>
    </div>
    <div className='grid grid-cols-1 gap-5 my-3 text-center sm:grid-cols-4 lg:grid-cols-3'>
      <div className="col-span-1 py-3 sm:col-span-2 lg:col-span-1">
        <div className="flex flex-col items-center justify-around lg:flex-row">
          <h6 className='font-bold'>เวลารวม</h6>
          <h2 className={`font-bold `}>{record.totalTime ? totalTime(record, downtimeBaseTime) : '-'}</h2>
          <small>นาที</small>
        </div>
        <h5 className={`${record.totalTime && record.downtimeBaseTime ? '':'hidden'}`}>{`(${getMinuteTimeV2(record.startedTime, record.finishedTime)} - ${downtimeBaseTime} นาที)`}</h5>
      </div>
      <div className='flex flex-col items-center justify-around py-3 lg:flex-row'>
        <h6 className='font-bold'>เวลารวมRT</h6>
        <h2 className='font-bold'>{
          record.totalEmployeeRT ? (totalTime(record, downtimeBaseTime) * record.totalEmployeeRT > 0 ? totalTime(record, downtimeBaseTime) * record.totalEmployeeRT : '-') : '-'
        }</h2>
        <small>นาที</small>
      </div>
      <div className='flex flex-col items-center justify-around py-3 lg:flex-row'>
        <h6 className='font-bold'>เวลารวมOT</h6>
        <h2 className='font-bold'>{
          record.totalEmployeeOT ? (totalTime(record, downtimeBaseTime) * record.totalEmployeeOT > 0 ? totalTime(record, downtimeBaseTime) * record.totalEmployeeOT : '-') : '-'
        }</h2>
        <small>นาที</small>
      </div>
    </div>
    <Modal show={showConfirm} onHide={handleClose}
      title='บันทึกข้อมูล'
      okText='ยืนยัน'
      cancelText='แก้ไข'
      okAction={onSaveRecord}
      okTheme='success'
      maxWidth={'max-w-lg'}
    >
      <div className="flex flex-col items-center justify-center gap-2 ">
        <p>คุณกำลังบันทึกของกะ</p>
        {record.shift === '1' && <h3 className="font-bold text-orange-400 ">{SHIFT.ROMKLAO.display}</h3>}
        {record.shift === '2' && <h3 className="font-bold text-cyan-400">{SHIFT.MINBURI.display}</h3>}
        {validateForm(record) ? 
          <Alert variation="success">
            ข้อมูลครบถ้วน กดยืนยันเพื่อบันทึก
          </Alert> : 
          <Alert variation="warning" heading="กรอกข้อมูลยังไม่ครบ">
            ขาดเวลาเริ่ม/เวลาหยุด หรือจำนวนคน, คุณสามารถกลับเข้ามาแก้ไขได้ กดยืนยันเพื่อบันทึก
          </Alert>}
        {errorSave && <Alert variation="error">{errorSave}</Alert>}
      </div>
    </Modal>
    <MessageConfirmDialog show={showWarningReset} title="Reset การบันทึกเวลาทั้งหมด"
      handleClose={() => setShowWarningReset(false)}
      onConfirm={resetTimeRecord} body="คุณต้องการล้างข้อมูลการบันทึกเวลาทั้งหมด ?"
      confirmTheme="danger" />
    <MessageConfirmDialog show={showWarningNotSave} title="ข้อมูลยังไม่ถูกบันทึก"
      handleClose={onBack}
      onConfirm={onSaveRecord} body="คุณยังไม่ได้มีการบันทึกข้อมูล คุณต้องการบันทึกข้อมูลหรือไม่ ?"
      confirmTheme="success"
      cancelText="ไม่บันทึก"
      confirmText="บันทึก" />
    <Modal show={showAlertSaveOnMidNight}
      title='แจ้งให้ทราบ'
      okText='รับทราบ'
      okAction={() => setShowAlertSaveOnMidNight(false)}>
      <h6>วัน "เริ่มผลิต" กับ "ผลิตจบ" เป็นคนละวันกัน ระบบจะทำการบันทึกแยกวันให้อัตโนมัติ</h6>
    </Modal>
  </div>
}

const validateForm = (record) => {
  if (record.timeType === OperationTime.SETUP_TIME) {
    return record.mch && (record.totalEmployeeRT || record.totalEmployeeOT) && record.startedTime && record.finishedTime
  } else if (record.timeType === OperationTime.RUN_TIME) {
    return record.mch && (record.totalEmployeeRT || record.totalEmployeeOT) && record.startedTime && record.finishedTime && record.yield
  } else if (record.timeType === OperationTime.DOWN_TIME) {
    return record.mch && (record.totalEmployeeRT || record.totalEmployeeOT) && record.startedTime && record.finishedTime && record.downtimeCode
  } else if (record.timeType === OperationTime.SOAP_BASE) {
    return record.bulkUsedQty
  }
  return false
}

const isDisableSubmit = (record, isRequiredLot) => {
  if (!record) return false
  const invalidRT = record.totalEmployeeRT && (record.totalEmployeeRT <= 0 || record.totalEmployeeRT > 100)
  const invalidOT = record.totalEmployeeOT && (record.totalEmployeeOT <= 0 || record.totalEmployeeOT > 100)
  const invalidMch = !record.mch
  const invalidShift = !record.shift
  if (record.timeType === OperationTime.SOAP_BASE) {
    return invalidRT || invalidOT || !record.batchNo
  } else if (record.timeType === OperationTime.DOWN_TIME) {
    return !record.startedTime || invalidRT || invalidOT || !record.batchNo || !record.downtimeCode || invalidMch
  } else if (record.operationNo === '0010') {
    return !record.startedTime || invalidRT || invalidOT || invalidMch || invalidShift
  } else {
    if (isRequiredLot === false) return !record.startedTime || invalidRT || invalidOT || invalidMch || invalidShift
    return !record.startedTime || invalidRT || invalidOT || !record.batchNo || invalidMch || invalidShift
  }
}

const updateInProgressOrder = async (order, setOrder, postingDate) => {
  try {
    const originalOrder = await DataStore.query(DgtPdProductionOrder, order.id)
    if (originalOrder && originalOrder.statusFromApp === OrderStatusCode.READY) {
      const updatedOrder = DgtPdProductionOrder.copyOf(originalOrder, updated => {
        updated.statusFromApp = OrderStatusCode.IN_PROGRESS
        updated.actualDueDate = postingDate
      })
      await DataStore.save(updatedOrder)
      setOrder(updatedOrder)
    } else {
      if (order.statusFromApp === OrderStatusCode.READY) {
        const updatedOrder = await updateInProgressDirectly(order.id, order._version, postingDate)
        console.log('update to server', updatedOrder)
        setOrder(updatedOrder)
      }
    }
  } catch (error) {
    console.log(error)
  }
}

const EditStartStopTime = ({ start, onStartDateTimeChanged, stop, onStopDateTimeChanged }) => {
  return <div className='flex flex-col gap-3 mt-2'>
    <div className='text-center'>
      <DatePicker
        className="input-form-date"
        selected={start}
        onChange={onStartDateTimeChanged}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={1}
        dateFormat="dd/MM/yyyy HH:mm"
        selectsStart
        startDate={start}
        endDate={stop}
      />
      <small className="float-right">เวลาเริ่ม</small>
    </div>
    <div className='text-center'>
      <DatePicker
        className="input-form-date"
        selected={stop}
        onChange={onStopDateTimeChanged}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={1}
        dateFormat="dd/MM/yyyy HH:mm"
        selectsEnd
        startDate={start}
        endDate={stop}
      />
      <small className="float-right">เวลาจบ</small>
    </div>
  </div>
}

const getDiscountDowntime = (order, rawBase) => {
  const baseTimeForBulk = convertJson(rawBase)
  if (isTomi(order)) {
    return baseTimeForBulk.TM
  }
  if (order.division === DivisionValue.TLT) {
    return baseTimeForBulk.TT
  } else if (order.division === DivisionValue.HHD) {
    return baseTimeForBulk.HH
  }
}

const totalTime = (record, downtimeBaseTime) => {
  const totalTimeMin = getMinuteTimeV2(record.startedTime, record.finishedTime) - downtimeBaseTime
  return totalTimeMin < 0 ? 0 : totalTimeMin
}

const isTomi = (order) => {
  return ['TMB'].includes(order.materialMrp) || order.materialDescription.startsWith('TMB')
}

const removeNulOrEmpty = (obj) => {
  Object.keys(obj).filter(key => key !== 'batchNo').forEach(key => {
    if (obj[key] === null || obj[key] === '' 
      || ['createdAt', 'updatedAt'].includes(key) || key.startsWith('_')) {
      delete obj[key];
    }
  });
}

export default WorkCenterForm